import { logTokenUsageToApi } from '@/features/Functions/SaveToken';

export const streamOpenAIResponse = async (
  prompt: string,
  tool: string,
  onStream: (message: string, tokenInfo?: { promptTokens: number; totalTokens: number }) => void
): Promise<void> => {
  const apiKey = process.env.NEXT_PUBLIC_OPENAI_API_KEY_AZURE;


  const baseUrl = process.env.NEXT_PUBLIC_OPENAI_4o_mini_AZURE;

  const headers = {
    'api-key': apiKey,
    'Content-Type': 'application/json',
  };

  const params = {
    max_tokens: 1000,
    temperature: 0.6,
    messages: [{ role: 'user', content: prompt }], // Only user prompt
    stream: true,
    stream_options: { include_usage: true }, // Enable token usage reporting
  };

  const response = await fetch( baseUrl , {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(params),
  });

  if (!response.ok || !response.body) {
    console.error('Failed to connect to OpenAI API');
    return;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let result = '';
  let usageLogged = false; // Flag to track if usage has been logged

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;

    const chunk = decoder.decode(value, { stream: true });

    // Split and process each line of the response
    const lines = chunk.split('\n').filter(line => line.trim() !== '' && !line.startsWith('data: [DONE]'));

    for (let line of lines) {
      if (line.startsWith('data: ')) {
        line = line.slice(5);
      }

      try {
        const data = JSON.parse(line);
        const content = data?.choices?.[0]?.delta?.content;

        if (content) {
          result += content;
          onStream(content);
        }
        if (data?.usage && !usageLogged) {
          const totalTokensUsed = data.usage.total_tokens;

          await logTokenUsageToApi( tool, totalTokensUsed);

          usageLogged = true; // Mark that usage has been logged
        }
      } catch (error) {
        console.warn('Error parsing stream data:', error, line);
      }
    }
  }

};
